import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import { Prompt } from 'react-router-dom';
import StateTransitionUserGroupListComponent from './StateTransitionUserGroupListComponent';
import {
  TableContainerMaxHeight,
  TableCellStickyColumn,
  TableCellHeaderStickyTopAndLeft,
  TableCellStyledWithHeaderTextValueSmall,
  HasImageIcon
} from 'components/list/TableComponentsStyled';
import { RoundedHeaderTableRow } from 'components/common/table/TableStyles';
import { IconButton } from '@totalsoft/rocket-ui';
import FlexBox from 'components/common/FlexBox';

const StateTransitionListItemComponent = ({
  stateTransitions,
  userGroups,
  onEdit,
  onRemove,
  dispatch,
  changedStateTransitionsPermissions,
  changed
}) => {
  const { t } = useTranslation();
  const onDeleteItem = stateTransitionId => {
    if (window.confirm(t('DocumentTypes.DocumentWithStateTransitions.Delete'))) {
      onRemove(stateTransitionId);
    }
  };
  return (
    <>
      <Prompt when={changed} message={t('LeavingWithoutSaving')} />
      <TableContainerMaxHeight>
        <Table stickyHeader>
          <TableHead>
            <RoundedHeaderTableRow>
              <TableCellHeaderStickyTopAndLeft>
                {t('DocumentTypes.DocumentWithStateTransitions.Transition')}
              </TableCellHeaderStickyTopAndLeft>
              {userGroups.map((userGroup, index) => {
                return <TableCellStyledWithHeaderTextValueSmall key={index}>{userGroup.name}</TableCellStyledWithHeaderTextValueSmall>;
              })}
            </RoundedHeaderTableRow>
          </TableHead>
          <TableBody>
            {stateTransitions.map(stateTransition => {
              return (
                <TableRow key={stateTransition.id} hover>
                  <TableCellStickyColumn>
                    <FlexBox gap={0.5} alignItems='center'>
                      <IconButton
                        color='primary'
                        variant='text'
                        size='tiny'
                        type='edit'
                        tooltip={t('Edit')}
                        onClick={onEdit(stateTransition.id)}
                      />
                      <IconButton
                        color='primary'
                        variant='text'
                        size='tiny'
                        type='delete'
                        tooltip={t('Delete')}
                        onClick={() => onDeleteItem(stateTransition.id)}
                      />
                      {`${stateTransition.fromStateName ?? ' '}  →  ${stateTransition.toStateName}`}
                      {stateTransition.saveImage && (
                        <Tooltip title={t('DocumentTypes.DocumentWithStateTransitions.SavesImage')}>
                          <HasImageIcon />
                        </Tooltip>
                      )}
                    </FlexBox>
                  </TableCellStickyColumn>
                  <StateTransitionUserGroupListComponent
                    key={stateTransition.id}
                    userGroups={userGroups}
                    stateTransition={stateTransition}
                    changedStateTransitionsPermission={changedStateTransitionsPermissions[stateTransition.id] || {}}
                    dispatch={dispatch}
                  />
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainerMaxHeight>
    </>
  );
};

StateTransitionListItemComponent.propTypes = {
  stateTransitions: PropTypes.array.isRequired,
  userGroups: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  changedStateTransitionsPermissions: PropTypes.object.isRequired,
  changed: PropTypes.bool
};

export default memo(StateTransitionListItemComponent);
